import { render, staticRenderFns } from "./myArea.vue?vue&type=template&id=306dd126&scoped=true"
import script from "./myArea.vue?vue&type=script&lang=js"
export * from "./myArea.vue?vue&type=script&lang=js"
import style0 from "./myArea.vue?vue&type=style&index=0&id=306dd126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306dd126",
  null
  
)

export default component.exports